import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import { ToastContainer } from "react-toastify";
import RegisterForm from "./Pages/Register";
import Camera from "./Pages/Camera";
import Thankyou from "./Pages/Thankyou";
import Video from "./Pages/Video";

function App() {
  return (
    <BrowserRouter>
      <ToastContainer />
      <Routes>
        <Route path="/" element={<RegisterForm />} />
        <Route path="/camera" element={<Camera />} />
        <Route path="/thankyou" element={<Thankyou />} />
        <Route path="/latest" element={<Video />} />

        {/*  <Route path="/gender" element={<SelectGender />} />
        <Route path="/latest" element={<Latest />} />
        <Route path="/loading" element={<Loading />} /> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
